const TIME = {
    ACCOUNT: {
        cookieTtlInMilliseconds: 14 * 24 * 60 * 60 * 1000,
    },
};

export default TIME;
